import { Box } from '@mui/material';
import { GridFooter, GridFooterContainer } from '@mui/x-data-grid';
import React from 'react'
import './ShelfLifeCustomFooter.css'

const ShelfLifeCustomFooter = () => {
    return (
      
        <Box className='shelf_life_footer_container'>
        <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
          <Box sx={{ width: 10, height: 10, bgcolor: '#17B4A3', borderRadius: '50%', mr: 1 }} />
          <span> &gt;70% shelf life remaining</span>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
          <Box sx={{ width: 10, height: 10, bgcolor: '#CC911F', borderRadius: '50%', mr: 1 }} />
          <span> &le;70% and &gt;30% shelf life remaining</span>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
          <Box sx={{ width: 10, height: 10, bgcolor: '#fd5c63', borderRadius: '50%', mr: 1 }} />
          <span> &le;30% shelf life remaining</span>
        </Box>
      </Box>
      
    );
  };

export default ShelfLifeCustomFooter